import React, { useState, useEffect } from 'react';
import { customerAPI } from '../../services/api';
import { format } from 'date-fns';
import { Bell, CheckCheck } from 'lucide-react';

export default function CustomerNotifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [marking, setMarking] = useState(false);

  const load = async () => {
    try {
      const { data } = await customerAPI.listNotifications({ limit: 50 });
      setNotifications(data.data || []);
    } catch { /* fail silent — inbox just shows empty */ }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const handleOpen = async (n) => {
    if (!n.read) {
      setNotifications(list => list.map(x => x._id === n._id ? { ...x, read: true } : x));
      customerAPI.markNotificationRead(n._id).catch(() => {});
    }
    if (n.url && n.url !== '/portal') window.location.href = n.url;
  };

  const handleMarkAll = async () => {
    setMarking(true);
    setNotifications(list => list.map(x => ({ ...x, read: true })));
    try { await customerAPI.markAllNotificationsRead(); } catch { /* badge will recount on next visit */ }
    finally { setMarking(false); }
  };

  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <div>
      <div className="flex justify-between items-center mb-6" style={{ flexWrap: 'wrap', gap: 10 }}>
        <div>
          <h2 style={{ fontSize: '1.2rem', fontWeight: 700 }}>Notifications</h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '.85rem' }}>Offers and updates from us</p>
        </div>
        {unreadCount > 0 && (
          <button className="btn btn-secondary" onClick={handleMarkAll} disabled={marking}>
            <CheckCheck size={14} /> Mark all read
          </button>
        )}
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 40 }}><div className="spinner" style={{ margin: '0 auto' }} /></div>
      ) : notifications.length === 0 ? (
        <div className="empty-state card" style={{ padding: 48 }}>
          <Bell size={32} />
          <h3>No notifications yet</h3>
          <p>Offers and updates will show up here.</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: 12 }}>
          {notifications.map(n => (
            <div
              key={n._id}
              className="card"
              style={{ cursor: n.url && n.url !== '/portal' ? 'pointer' : 'default', position: 'relative' }}
              onClick={() => handleOpen(n)}
            >
              <div style={{ padding: '14px 18px', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                {!n.read && (
                  <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--primary)', marginTop: 6, flexShrink: 0 }} />
                )}
                {n.image && (
                  <img src={n.image} alt="" style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: 8, flexShrink: 0 }} />
                )}
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div style={{ fontWeight: n.read ? 600 : 700, fontSize: '.95rem' }}>{n.title}</div>
                  <div style={{ fontSize: '.85rem', color: 'var(--text-muted)', marginTop: 2 }}>{n.body}</div>
                  <div style={{ fontSize: '.72rem', color: 'var(--text-muted)', marginTop: 6 }}>
                    {format(new Date(n.createdAt), 'dd MMM yyyy, h:mm a')}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
